module.exports = __webpack_public_path__ + "static/img/IMG_20151222_143939.7d753cfe.jpg";